
















import { defineComponent, ref, Ref, computed, ComputedRef, watch, onUnmounted } from '@vue/composition-api';

import TeamTree from '@/renderer/components/TeamTree/index.vue';
import SpacePage from '@/renderer/components/SpacePage/list.vue';

import { SMH } from '@/renderer/scripts/smh';
import user, { User } from '@/renderer/scripts/utils/user';
import storage from '@/renderer/scripts/utils/storage';
import accessTokenManager from '@/renderer/scripts/utils/AccessTokenManager/space';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';

import { openJumpToWorkbenchDialog } from '@/renderer/scripts/composition/dialogHandler';
import { teamSpaceDrawerHandler } from './teamSpaceDrawerHandler';

interface SelectedTeam extends SpaceBaseInfo, SMH.TeamTreeNode {}

type TeamPathInfo = {
  path: string[];
  spaceId: string;
  id: number;
  orgId: number;
};
export default defineComponent({
  components: {
    TeamTree,
    SpacePage,
  },
  setup(props, context) {
    const vm = context.root;
    const defaultTeamPath = ref<string[] | boolean>(false);
    const orgShow = ref(true);
    /**
     * @description 当前选中的团队
     * 包含 teamTreeNode 和 tokenItem 全部信息
     */
    const selectedTeam: Ref<SelectedTeam> = ref({} as SelectedTeam);
    /**
     * @description 当前选中的团队的基本信息 供 SpacePage 组件使用
     */
    const spaceId: ComputedRef<SMH.SpaceId> = computed(() => selectedTeam.value.spaceId);
    const teamId: ComputedRef<SMH.TeamId> = computed(() => selectedTeam.value.id);
    /**
     * @description 点击菜单项以切换团队
     */
    const onChangeTeam = async (node: { data: SMH.TeamTreeNode; init: boolean }) => {
      if (!node) return;
      const teamTreeNode = node.data;
      const tokenItem = await accessTokenManager.get(teamTreeNode.spaceId);
      selectedTeam.value = {
        ...teamTreeNode,
        ...tokenItem,
      };
      // 切换团队时需删除路由上的路径
      Object.keys(vm.$route.query).length > 0 && dispatchRouter({ name: vm.$route.name as string }, 'replace');
      // 切换团队时需要保存当前团队路径，以便刷新或切换路由时仍能回到上次进入的团队
      // 这里记录的teamPath需要和企业绑定
      storage.set(storage.StoreKey.TEAM_PATH, {
        path: [...(selectedTeam.value.path || [])],
        spaceId: selectedTeam.value.spaceId,
        id: selectedTeam.value.id,
        orgId: vm.$store.getters.orgId,
      });
    };
    const initByURL = async () => {
      const { query } = vm.$router.currentRoute;
      const { spaceId, teamId, teamPath } = query as any as {
        spaceId: string;
        teamId: number;
        teamPath: string;
        orgId: number;
      };
      const pathArray = teamPath.split('/');
      const path = pathArray || [];
      try {
        const space = await accessTokenManager.get(spaceId);
        selectedTeam.value = {
          ...space,
          name: path[path.length - 1],
          id: Number(teamId),
        } as unknown as SelectedTeam;
      } catch (error) {
        openJumpToWorkbenchDialog(vm.$route.name as string);
      }
    };
    const initData = async () => {
      // 切换身份后这里只会恢复当前企业的teamPath
      const currentUserInfo: User.FlatUserInfo = user.getUserInfo();
      const currentOrgId = currentUserInfo.organizationId || 0;
      const teamPathInfo = storage.get<TeamPathInfo | null>(storage.StoreKey.TEAM_PATH) as TeamPathInfo;
      if (teamPathInfo) {
        const { path, spaceId, id, orgId } = teamPathInfo;
        if (currentOrgId !== orgId) {
          defaultTeamPath.value = true;
          return;
        }
        defaultTeamPath.value = path;
        const space = await accessTokenManager.get(spaceId);
        selectedTeam.value = {
          ...space,
          name: path[path.length - 1],
          id,
        } as unknown as SelectedTeam;
      } else {
        defaultTeamPath.value = true;
      }
    };
    const computedParams = computed<Drawer.TeamSpaceDynamicParams>(() => {
      let params;
      if (vm.$route.query.spaceId && vm.$route.query.teamId && vm.$route.query.teamPath && vm.$route.query.path) {
        params = {
          teamId: vm.$route.query.teamId as string,
          spaceId: `${vm.$route.query.spaceId}`,
          teamPath: vm.$route.query.teamPath as string,
        };
      } else {
        const teamPathInfo = storage.get<TeamPathInfo | null>(storage.StoreKey.TEAM_PATH) as TeamPathInfo;
        params = {
          teamPath: [...(teamPathInfo.path || [])].join('/'),
          spaceId: teamPathInfo.spaceId,
          teamId: `${teamPathInfo.id}`,
        };
      }
      return params;
    });
    const { setDefaultDrawer } = teamSpaceDrawerHandler(computedParams, spaceId);
    const init = async () => {
      const { query } = vm.$router.currentRoute;
      const { teamPath } = query;
      if (teamPath) {
        // 有teamPath足够证明参数的url都传递了
        await initByURL();
      } else {
        await initData();
      }
      // todo updateDrawer (在路由改变的时候，需要留意更新参数）
      setDefaultDrawer(computedParams);
    };

    init();
    watch(
      () => vm.$route,
      val => {
        init();
      },
    );
    return {
      defaultTeamPath,
      onChangeTeam,
      selectedTeam,
      spaceId,
      teamId,
      orgShow,
    };
  },
});
